import { darkPalette } from "../palette";

export const MuiListItem = {
  MuiListItem: {
    styleOverrides: {
      root: {
        borderBottom: `1px solid ${darkPalette.background.paper}`,
        "&:hover": {
          backgroundColor: darkPalette.background.paper,
        },
      },
    },
  },
};
